'use client';
'use strict';

var classes = {"root":"m-6e45937b","loader":"m-e8eb006c","overlay":"m-df587f17"};

module.exports = classes;
//# sourceMappingURL=LoadingOverlay.module.css.cjs.map
